export default "__VITE_ASSET__DaM_DoHv__"